<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Why development teams choose Capawesome Cloud over Ionic Appflow'
    "
    [icon]="'@tui.trophy'"
    [subtitle]="'Key Advantages'"
    [title]="'Better features, lower costs, superior support'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
    <!-- Active Innovation -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.rocket" class="mr-2" />
        <h3 class="text-xl font-bold">Active Innovation</h3>
      </div>
      <p class="text-pretty text-lg">
        Appflow is discontinued after December 2027. We're actively developing
        new features and improvements for your mobile CI/CD needs.
      </p>
    </div>
    <!-- Significant Cost Savings -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.dollar-sign" class="mr-2" />
        <h3 class="text-xl font-bold">Up to 10x Lower Costs</h3>
      </div>
      <p class="text-pretty text-lg">
        Starting at $9/month with builds and updates vs Appflow's $49/month. Get
        200 build minutes and 1,000 updates included. Save thousands on your
        budget.
      </p>
    </div>
    <!-- Blazing Fast Builds -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.zap" class="mr-2" />
        <h3 class="text-xl font-bold">Blazing Fast Builds</h3>
      </div>
      <p class="text-pretty text-lg">
        M4 runners with 4 CPU cores and 14 GB RAM deliver 3-5x faster builds.
        Spend less time waiting and more time shipping features to users.
      </p>
    </div>
    <!-- Superior Features -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.zap" class="mr-2" />
        <h3 class="text-xl font-bold">Superior Features</h3>
      </div>
      <p class="text-pretty text-lg">
        Advanced Live Updates with automatic rollbacks and custom device IDs.
        Native Builds and App Store Publishing in one unified platform.
      </p>
    </div>
    <!-- Enhanced Security -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.shield-check" class="mr-2" />
        <h3 class="text-xl font-bold">Enhanced Security</h3>
      </div>
      <p class="text-pretty text-lg">
        Zero-trust architecture, EU hosting options, and no personal data
        collection. Fully open-source SDK for complete transparency and
        security.
      </p>
    </div>
    <!-- Privacy-First -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.eye-off" class="mr-2" />
        <h3 class="text-xl font-bold">Privacy-First Approach</h3>
      </div>
      <p class="text-pretty text-lg">
        We don't collect personal data and offer EU-based hosting. Perfect for
        GDPR compliance and privacy-conscious teams building user-focused apps.
      </p>
    </div>
  </div>
</section>
